export const STATE = {
	IDLE:       'idle',
	QUEUED:     'queued',
	CREATED:    'created',
	PROCESSING: 'processing',
	COMPLETED:  'completed',
	FAILED:     'failed',
	ABORTED:    'aborted',
};
